<template>
  <div class="tables">
    <div>
      <h6>位置信息</h6>
      <p><span>使用目的</span> <span>用于筛选推荐商品、对外展示</span></p>
      <p><span>使用场景</span> <span>用户注册、修改个人信息</span></p>
      <p>
        <span>收集情况</span> <span>{{ user.address!== '-' ? "用户提供，已收集1条" : "未收集" }}</span>
      </p>
      <p>
        <span>信息内容</span> <span>{{ user.address}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getSellerInfo } from "@/api/seller";
export default {
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    this._getUserInfo()
  },
  methods: {
    async _getUserInfo(){
        const res = await getSellerInfo({});
        if(res.appStatus.errorCode == 0){
            this.user = {...res.content}
        }
    }
  },
};
</script>

<style lang="scss" scoped>
.tables {
  margin: 10px;
  padding-bottom: 30px;
  > div {
    margin-top: 20px;
    background: #d9d9d9;
    h6 {
      background: #fff;
    }
    p {
      font-size: 14px;
      display: flex;
      line-height: 30px;
      span:first-child {
        background: #d9d9d9;
        width: 100px;
        text-align: center;
      }
      span:last-child {
        width: 100%;
        display: block;
        background: #fff;
        border: 1px solid #d9d9d9;
        text-align: center;
      }
    }
  }
}
</style>
